import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import './OrderConfirmation.css';

const OrderConfirmation = ({ order }) => {
  const containerRef = useRef(null);
  const progressRef = useRef(null);

  useEffect(() => {
    // Enhanced entrance animation with bounce
    gsap.fromTo(
      containerRef.current,
      { opacity: 0, scale: 0.9 },
      { 
        opacity: 1, 
        scale: 1,
        duration: 0.6, 
        ease: 'back.out(1.5)'
      }
    );

    // Success checkmark animation
    gsap.timeline()
      .fromTo('.confirmation-icon',
        { scale: 0, rotation: -180 },
        { 
          scale: 1.2,
          rotation: 0,
          duration: 0.5,
          ease: 'back.out(2)',
          delay: 0.2
        }
      )
      .to('.confirmation-icon', {
        scale: 1,
        duration: 0.3,
        ease: 'elastic.out(1, 0.5)'
      });

    // Sparkles animation
    gsap.fromTo('.sparkle',
      { scale: 0, opacity: 0 },
      {
        scale: 1,
        opacity: 1,
        duration: 0.4,
        stagger: 0.1,
        delay: 0.5,
        ease: 'back.out(2)'
      }
    );

    // Text animations with stagger
    const textElements = ['.confirmation-title', '.confirmation-message', '.order-details'];
    gsap.fromTo(
      textElements,
      { y: 30, opacity: 0 },
      { 
        y: 0, 
        opacity: 1,
        duration: 0.5,
        stagger: 0.15,
        delay: 0.4,
        ease: 'power3.out'
      }
    );

    // Progress bar with shimmer
    gsap.fromTo(progressRef.current,
      { width: '0%' },
      { 
        width: '100%',
        duration: 5,
        ease: 'power1.inOut',
        delay: 0.6
      }
    );

    // Preparing dots entrance
    gsap.fromTo('.preparing-dot',
      { scale: 0, y: 20 },
      {
        scale: 1,
        y: 0,
        duration: 0.4,
        stagger: 0.1,
        delay: 0.7,
        ease: 'back.out(2)'
      }
    );

  }, []);

  return (
    <div className="order-confirmation" ref={containerRef}>
      <div className="confirmation-content">
        <div className="icon-wrapper">
          <div className="icon-background"></div>
          <div className="confirmation-icon">✅</div>
          <div className="sparkle sparkle-1">✨</div>
          <div className="sparkle sparkle-2">✨</div>
          <div className="sparkle sparkle-3">✨</div>
          <div className="sparkle sparkle-4">✨</div>
        </div>

        <h1 className="confirmation-title">Order Confirmed!</h1>
        <p className="confirmation-message">Your coffee is being prepared...</p>

        {order && (
          <div className="order-details">
            <div className="detail-row">
              <span className="detail-label">Item:</span>
              <span className="detail-value">{order.coffee}</span>
            </div>
            <div className="detail-row">
              <span className="detail-label">Quantity:</span>
              <span className="detail-value">{order.quantity}</span>
            </div>
            <div className="detail-row total">
              <span className="detail-label">Total:</span>
              <span className="detail-value">{order.totalPrice}</span>
            </div>
          </div>
        )}

        <div className="progress-container">
          <div className="progress-bar" ref={progressRef}></div>
        </div>

        <div className="preparing-animation">
          <div className="preparing-dot"></div>
          <div className="preparing-dot"></div>
          <div className="preparing-dot"></div>
        </div>
      </div>

      <div className="confirmation-corners">
        <span className="c-corner c-corner-tl"></span>
        <span className="c-corner c-corner-tr"></span>
        <span className="c-corner c-corner-bl"></span>
        <span className="c-corner c-corner-br"></span>
      </div>
    </div>
  );
};

export default OrderConfirmation;
